module.exports = __webpack_public_path__ + "img/img01.1e0266c5.png";